<template>
  <div class="animated fadeIn">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10">
          <div class="card-group mb-0">
            <div class="card p-3">
              <div class="card-body">

                <change-password></change-password>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ChangePassword from '@/components/auth/ChangePassword'

  export default {
    components: {
      ChangePassword
    }
  }

</script>



// WEBPACK FOOTER //
// src/views/ChangePassword.vue?4ef5c638